import { Fragment, useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import { Link, useHistory } from 'react-router-dom';
import { SettingsHeader } from '../components/Settings';
import '../components/Settings/Settings.css';
import ManageUserIcon from '../images/manageuser-icon.svg';
import GrievanceBtn from '../images/apps-grievance.png'

const Settings = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showSetPermission, setShowSetPermission] = useState(false);
    const [showCreateUser, setShowCreateUser] = useState(false);
    const [showManageReset, setShowManageReset] = useState(false);
    const [showManageUser, setShowManageUser] = useState(false);
    const [showGrievance, setShowGrievance] = useState(false);
    const [showManagePayrollPic, setShowManagePayrollPic] = useState(false);

    //!== Toggle the "Manage User" dropdown visibility
    const [dropdown, setShowDropdown] = useState(false);
    const showDropDown = () => setShowDropdown(!dropdown);

    //!== Toggle the "Grievance" dropdown visibility 
    const [dropdownGrievance, setShowDropdownGrievance] = useState(false);
    const showDropDownGrievance = () => setShowDropdownGrievance(!dropdownGrievance);

    //!== To detect clicks outside of DOM elements --- "Manage User" and "Grievance" to close the dropdowns
    const ref = useRef();
    const refgrievnace =useRef();

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (dropdown && ref.current && !ref.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [dropdown, ref]); // rebuild the UI when "dropdown" / "ref" changes

    useEffect(() => {
        const checkIfClickedOutsideGrievance = (e) => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (dropdownGrievance && refgrievnace.current && !refgrievnace.current.contains(e.target)) {
                setShowDropdownGrievance(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutsideGrievance);
        return () => {
            // Cleanup the event listener
            document.removeEventListener('mousedown', checkIfClickedOutsideGrievance);
        };
    }, [dropdownGrievance, refgrievnace]);

    const history = useHistory();

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;
            
            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes(
                        'Create Bus Driver Account'
                    ) &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Reset Phone Number') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Reset Password') &&
                        item.permissionType.includes('view'))
            );
            
            const manageGrievancePermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Grievance Setting') &&
                        item.permissionType.includes('view')) 
            );

            if (permit) {
                setShowManageUser(true);
                setShowGrievance(true);
                setIsLoading(false);
            } 
            else if (manageGrievancePermit) {
                setShowGrievance(true);
                setIsLoading(false);
            }
            else {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            }

            const setPermissionPermit = loginListFromParent.some(
                (item) =>
                    item.permissionName.includes('Admin Role') &&
                    item.permissionType.includes('view')
            );

            if (setPermissionPermit) {
                setShowSetPermission(true);
                setShowManagePayrollPic(true)
            }

            const createUserPermit = loginListFromParent.some(  
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes(
                        'Create Bus Driver Account'
                    ) &&
                        item.permissionType.includes('view'))
            );

            if (createUserPermit) {
                setShowCreateUser(true);
            }

            const manageResetPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Reset Phone Number') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Reset Password') &&
                        item.permissionType.includes('view'))
            );

            if (manageResetPermit) {
                setShowManageReset(true);
            }
        }
    }, [props.loginList]);

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <SettingsHeader />
                        <Row>
                            {showManageUser && (
                            <Col xs={6} md={3}>
                                    <div
                                        className='text-center settings-icon'
                                        ref={ref}
                                    >
                                        <Link to='#' onClick={showDropDown}>
                                            <img
                                                src={ManageUserIcon}
                                                className='settings-logo'
                                                alt=''
                                            />
                                        </Link>
                                        <Row>
                                            <span
                                                className='settings-title'
                                                onClick={showDropDown}
                                            >
                                                Manage User
                                            </span>
                                        </Row>
                                        <div className='settings-dropdown-menu'>
                                            {dropdown && (
                                                <div className='settings-dropdown-content'>
                                                    {showCreateUser && (
                                                        <button
                                                            className='settings-dropdown-btn'
                                                            onClick={() =>
                                                                history.push(
                                                                    '/settings/manageuser/managebusdriver'
                                                                )
                                                            }
                                                        >
                                                            Manage Bus Driver
                                                            Account
                                                        </button>
                                                    )}
                                                    {showManageReset && (
                                                        <button
                                                            className='settings-dropdown-btn'
                                                            onClick={() =>
                                                                history.push(
                                                                    '/settings/manageuser/resetuser'
                                                                )
                                                            }
                                                        >
                                                            Reset User Account
                                                        </button>
                                                    )}
                                                    {showSetPermission && (
                                                        <button
                                                            className='settings-dropdown-btn'
                                                            onClick={() =>
                                                                history.push(
                                                                    '/settings/manageuser/setpermission'
                                                                )
                                                            }
                                                        >
                                                            Set User Permissions
                                                        </button>
                                                    )}
                                                    {showManagePayrollPic && (
                                                        <button
                                                            className='settings-dropdown-btn'
                                                            onClick={() =>
                                                                history.push(
                                                                    '/settings/manageuser/managepayrollpic'
                                                                )
                                                            }
                                                        >
                                                            Manage Payroll PIC
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div> 
                            </Col>
                            )}
                            {showGrievance && (
                            <Col xs={6} md={3}>
                                    <div
                                        className='text-center settings-icon'
                                        ref={refgrievnace}
                                    >
                                        <Link to='#' onClick={showDropDownGrievance}>
                                            <img
                                                src={GrievanceBtn}
                                                className='settings-logo'
                                                alt=''
                                            />
                                        </Link>
                                        <Row>
                                            <span
                                                className='settings-title'
                                                onClick={showDropDownGrievance}
                                            >
                                                Grievance
                                            </span>
                                        </Row>
                                        <div className='settings-dropdown-menu'>
                                            {dropdownGrievance && (
                                                <div className='settings-dropdown-content'>
                                                    <button
                                                        className='settings-dropdown-btn'
                                                        onClick={() =>
                                                            history.push(
                                                                '/settings/grievance/permission'
                                                            )
                                                        }
                                                    >
                                                        PIC Master Setting
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                
                            </Col>
                            )}
                        </Row>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Settings;
